export default function Safety(){
    return(<><section className="section section-dark" id="safety">
  <div className="container">
    <p className="section-eyebrow light">Travel with confidence</p>
    <h2 className="section-title light">Your safety comes first</h2>
    <p className="section-sub light">
      Every ride on RouteRider is backed by verification, transparency and
      support.
    </p>
    <div className="feature-grid">
      <div className="feature-card reveal in">
        <span className="feature-icon">🪪</span>
        <h3>ID-verified drivers</h3>
        <p>
          Every driver goes through document &amp; background verification
          before they hit the road.
        </p>
      </div>
      <div className="feature-card reveal in">
        <span className="feature-icon">⭐</span>
        <h3>Ratings &amp; reviews</h3>
        <p>
          Real reviews from real riders help you choose the right driver and
          route.
        </p>
      </div>
      <div className="feature-card reveal in">
        <span className="feature-icon">📍</span>
        <h3>Live trip tracking</h3>
        <p>
          Share your live location with family so they always know you're on
          your way.
        </p>
      </div>
      <div className="feature-card reveal in">
        <span className="feature-icon">💳</span>
        <h3>Secure payments</h3>
        <p>Pay online or in cash — your transactions are always protected.</p>
      </div>
      <div className="feature-card reveal in">
        <span className="feature-icon">🎧</span>
        <h3>24×7 support</h3>
        <p>Our support team is one tap away, any hour, any day of the trip.</p>
      </div>
      <div className="feature-card reveal in">
        <span className="feature-icon">🔄</span>
        <h3>Easy cancellation</h3>
        <p>
          Plans change — cancel or reschedule free up to 2 hours before pickup.
        </p>
      </div>
    </div>
  </div>
</section>
</>)
}